//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherColumnMatchDisplayItem } from './TeacherColumnMatchDisplayItem';
import { NameFormat } from './Enums';

export class TeacherColumnMatchesDisplayItem extends ItemBase {
    Matches: TeacherColumnMatchDisplayItem[] = [];
    HasHeader: boolean = false;
    NameFormat: NameFormat | null = null;

    constructor(initializer?: Partial<TeacherColumnMatchesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherColumnMatchesDisplayItem";
}
